import React from "react";

export const PlusIcon = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 6.04199C10.3452 6.04199 10.625 6.32181 10.625 6.66699V9.375H13.334C13.6789 9.37535 13.959 9.65504 13.959 10C13.959 10.345 13.6789 10.6246 13.334 10.625H10.625V13.334C10.6247 13.6789 10.345 13.959 10 13.959C9.65503 13.959 9.37533 13.6789 9.375 13.334V10.625H6.66699C6.32181 10.625 6.04199 10.3452 6.04199 10C6.04199 9.65482 6.32181 9.375 6.66699 9.375H9.375V6.66699C9.375 6.32181 9.65482 6.04199 10 6.04199Z"
                  fill="#222222"/>
        </svg>
    );
}